// 时间相关通用工具方法，供财务管理等模块复用

import { DISPLAY_TIMEZONE, getCalendarPartsInTimeZone } from '@/utils/displayTimezone'
function getCurrentUnixByDisplayZone() {
  const now = new Date()
  const p = getCalendarPartsInTimeZone(now, DISPLAY_TIMEZONE)
  return Math.floor(now.getTime() / 1000)
}

function parseDateTimeString(str) {
  if (str == null) return null
  const s = String(str).trim()
  if (!s) return null

  // 支持：yyyy-MM-dd 或 yyyy-MM-dd HH:mm:ss
  const [datePart, timePartRaw] = s.split(' ')
  if (!datePart) return null
  const [yRaw, mRaw, dRaw] = datePart.split('-')
  const y = Number(yRaw)
  const m = Number(mRaw)
  const d = Number(dRaw)
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null

  let hh = 0
  let mm = 0
  let ss = 0
  if (timePartRaw) {
    const [hhRaw, mmRaw, ssRaw] = timePartRaw.split(':')
    hh = Number(hhRaw)
    mm = Number(mmRaw)
    ss = Number(ssRaw)
    if (![hh, mm, ss].every(n => Number.isFinite(n))) return null
  }
  return { y, m, d, hh, mm, ss }
}

function getOffsetMsInTimeZone({ y, m, d, hh, mm, ss }, timeZone) {
  // 构造一个“同分量的 UTC 时间”，再用 timeZoneName=shortOffset 解析该时区的 offset
  const utcMs = Date.UTC(y, m - 1, d, hh, mm, ss)
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZoneName: 'shortOffset',
  })
  const parts = dtf.formatToParts(new Date(utcMs))
  const tzPart = parts.find(p => p.type === 'timeZoneName')?.value || ''
  // 可能形式：GMT+1 / GMT+01:00 / UTC+1
  const m1 = String(tzPart).match(/([+-])(\d{1,2})(?::?(\d{2}))?/)
  if (!m1) return 0
  const sign = m1[1] === '-' ? -1 : 1
  const oh = Number(m1[2]) || 0
  const om = Number(m1[3]) || 0
  return sign * (oh * 60 + om) * 60 * 1000
}

export function lagosStringToEpochMs(dateStr) {
  const parsed = parseDateTimeString(dateStr)
  if (!parsed) return undefined
  const offsetMs = getOffsetMsInTimeZone(parsed, DISPLAY_TIMEZONE)
  const utcMs = Date.UTC(parsed.y, parsed.m - 1, parsed.d, parsed.hh, parsed.mm, parsed.ss)
  // 拉各斯墙上时间 = UTC + offset，因此 epoch = utcMs - offset
  return utcMs - offsetMs
}

// 将 yyyy-MM-dd HH:mm:ss 字符串转换为时间戳（毫秒，按拉各斯时区解释输入字符串）
export function toUnixSeconds(dateStr) {
  if (!dateStr) return undefined
  const ms = lagosStringToEpochMs(dateStr)
  return ms == null ? undefined : Math.floor(ms)
}

// 将时间戳（秒或毫秒）格式化为 yyyy/MM/dd HH:mm:ss 字符串（尼日利亚拉各斯时区）
export function formatTimestamp(timestamp) {
  if (!timestamp) return ''
  const ts = typeof timestamp === 'number' ? timestamp : Number(timestamp)
  if (!ts) return ''
  const ms = ts.toString().length === 10 ? ts * 1000 : ts
  const date = new Date(ms)
  if (Number.isNaN(date.getTime())) return ''
  const pad = n => (n < 10 ? `0${n}` : n)
  const p = getCalendarPartsInTimeZone(date, DISPLAY_TIMEZONE)
  const Y = p.y
  const M = pad(p.m)
  const D = pad(p.d)
  const h = pad(p.h)
  const m = pad(p.i)
  const s = pad(p.s)
  return `${Y}/${M}/${D} ${h}:${m}:${s}`
}
